module.exports = __webpack_public_path__ + "img/comment-feedback.62e3469e.svg";